import { useFormContext, Controller } from 'react-hook-form';
// @mui
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { useMemo, useState } from 'react';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  customOnchange?: any
};

export default function RHFTextField({ name, helperText, type, customOnchange, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            <TextField
              {...field}
              fullWidth
              type={type}
              value={type === 'number' && field.value === 0 ? '' : field.value}
              onChange={(event) => {
                if (type === 'number') {
                  field.onChange(Number(event.target.value));
                } else {
                  if (customOnchange) {
                    customOnchange(event.target.value, field.name);
                    // field.onChange(event);
                  } else {

                    field.onChange(event.target.value);
                  }
                }
              }}
              error={!!error}
              helperText={error ? error?.message : helperText}
              {...other}
            />
          </>
        )

      }}
    />
  );
}

// ----------------------------------------------------------------------

type Props2 = TextFieldProps & {
  name: string;
};

export function RHFTextField2({ name, helperText, type, ...other }: Props2) {
  const [internalError, setInternalError] = useState<any>({});
  const { control } = useFormContext();
  const defaultType = useMemo(() => {
    let newType = type;
    switch (type) {
      case 'digit':
      case 'decimal':
      case 'price':
      case 'percentage':
        return 'text';
      default:
        return newType;
    }
  }, [type]);

  const textOnChange = (event: any, field: any) => {
    switch (type) {
      case 'digit':
      case 'decimal':
      case 'price':
      case 'percentage':
        handleNumberChange(event, field);
        break;
      default:
        field.onChange(event.target.value);
        break;
    }

  }
  const handleNumberChange = (event: any, field: any) => {
    let value = event.target.value;
    console.log(value);
    if (type === 'price') {
      value = value.replaceAll(',', '');
    }
    // if its a number 
    if (!isNaN(value) && value !== '') {
      switch (type) {
        case 'digit':
          console.log('digit')
          field.onChange(Number(value));
          console.log(Number(value));
          break;
        case 'price':
          console.log('price');
          const parts = value.split('.');
          let formattedPrice = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          if (parts.length > 1) {
            formattedPrice += '.' + parts[1];
          }
          field.onChange(formattedPrice);
          console.log(formattedPrice);
          break;
        case 'decimal':
          console.log('decimal')
          if (value.endsWith(".") || value.endsWith("0")) { // try using 0.2 or 12.02 , this covers that 
            field.onChange(value);
          } else {
            field.onChange(Number(value));
          }
          break;
        case 'percentage':
          console.log('percentage');
          if (value.length > 6) { // stops decimals at 3 digit after decimal
            setInternalError({ message: 'Max 3 digit after decimal' });
          } else {
            if (Number(value) > 100) {
              field.onChange(value.slice(0, 2) + "." + value.slice(2));
            } else {
              setInternalError({});
              if (value.endsWith(".") || value.endsWith("0")) { // try using 0.2 or 12.02 , this covers that 
                field.onChange(value);
              } else {
                field.onChange(Number(value));
              }
            }
          }
          break;
        default:
          field.onChange(Number(value));
          break;
      }
    } else if (value === '') {
      field.onChange('');
      setInternalError({});
    }

  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={defaultType}
          // value={ defaultType === 'number' && field.value==='' || '' }
          onChange={(event) => {
            textOnChange(event, field)
          }}
          // error={(!!error )}
          // helperText={(error ) ? (error?.message ) : helperText}
          error={(!!error)}
          helperText={(error || internalError.message) ? (error?.message || internalError.message) : helperText}
          {...other}
        />
      )}
    />
  );
}
